import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Label } from "reactstrap";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";

import DashboardHeader from "../includes/dashboardHeader/DashboardHeader";
import DashboardSidebar from "../includes/dashboardSidebar/DashboardSidebar";
import FooterComponent from "../includes/dashboardFooter/FooterComponent";
import ModalPopup from "../common/ModalPopup";
import LocalAgentDrawer from "../AgenticSupport/LocalAgentDrawer";
import { getScenariosByModule } from "../AgenticSupport/localAgentConstants";
import Loader from "../Loader";
import { PainPointsWrapper } from "./Styling/PainPointInitiatives";
import "../AgenticSupport/AgenticSupport.css";

import {
  resetInitiatives,
  GetCapabilityPainPoints,
} from "../../actions/benchmarkingActions";
import { fetchProjects } from "../../actions/capabilityActions";
import { startLoader, stopLoader } from "../../actions/loaderActions";
import { responseMessage } from "../../utils/alert";
import CacheStorage from "../../utils/CacheStorage";
import { useHistory } from 'react-router-dom';
import { createKpi } from "../../actions/kpiActions";
import AiAssistIcon from "../AgenticSupport/AiAssistIcon";
import AiSuggestionPanel from "../AgenticSupport/AiSuggestionPanel";
import PremiumAgenticButton from "../AgenticSupport/PremiumAgenticButton";
import * as localAgentService from "../AgenticSupport/localAgentService";
import { RISK_REGISTER_SCENARIOS, MODULE_RISK_FULL_ANALYSIS } from "../AgenticSupport/localAgentConstants";


const config = require("../../config");

export default function PainPointInitiatives() {
  const { projectId, processID } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  // Redux
  const capabilityPainPoints = useSelector(state => state.benchmarkingData.capabilityPainPoints);


  // Local state
  const [tab, setTab] = useState("overview");
  const [listOrDomain, setListOrDomain] = useState("list");
  const [loading, setLoading] = useState(false);

  // Data
  const [overviewData, setOverviewData] = useState([]);
  const [activityData, setActivityData] = useState([]);
  const [selectedCapabilities, setSelectedCapabilities] = useState([]);
  const [unselectedCapabilities, setUnselectedCapabilities] = useState([]);

  const [checkedSelected, setCheckedSelected] = useState([]);
  const [checkedUnselected, setCheckedUnselected] = useState([]);

  const [saveMatrix, setSaveMatrix] = useState([]);
  const capabilityModellingProjectdropdownData = useSelector(
    state => state.capability.items
  );

  // Super Admin / Project Selection filtering logic
  const [filteredProjects, setFilteredProjects] = useState([]);

  useEffect(() => {
    // Check if we have a project selection context
    const userEmail = sessionStorage.getItem("userEmail") || localStorage.getItem("userEmail") || "";
    // Basic check for Super Admin or just general project selection usage if widely adopted
    // For now, restricting to the same logic: if context exists, use it.
    const projectSelectionStr = sessionStorage.getItem("projectSelection");

    let finalProjects = capabilityModellingProjectdropdownData;

    if (userEmail && userEmail.toLowerCase() === "superadmin@amplo.com" && projectSelectionStr) {
      try {
        const projectSelection = JSON.parse(projectSelectionStr);
        // Check for Capability Project
        if (projectSelection.capProject && projectSelection.capProject.DecompositionProjectID) {
          const selectedId = String(projectSelection.capProject.DecompositionProjectID);

          // 1. Filter dropdown to only show this project
          const contextProject = capabilityModellingProjectdropdownData.find(
            p => String(p.DecompositionProjectID) === selectedId
          );

          if (contextProject) {
            finalProjects = [contextProject];

            // 2. Redirect/Enforce if URL doesn't match
            // Current URL param is `projectId` (from useParams)
            if (String(projectId) !== selectedId) {
              // Construct the new URL maintaining other params if possible, or defaulting
              // Route: /painpoint-initiatives/:projectId/:projectName/:processID
              // We use 'undefined' for the name param as per existing pattern (Sidebar)
              const newName = 'undefined';
              const newProcessId = '0'; // Defaulting to 0 as standard entry point

              history.push(`/painpoint-initiatives/${selectedId}/${newName}/${newProcessId}`);
            }
          }
        }
      } catch (e) {
        console.error("Error parsing project selection for PainPoints:", e);
      }
    }
    setFilteredProjects(finalProjects);

  }, [capabilityModellingProjectdropdownData, projectId, history]);


  const projectOptions = filteredProjects.map((project, i) => {
    const uniqId = project.ProjectName.trim() + '-' + i;
    return (
      <option value={project.DecompositionProjectID} key={uniqId}>
        {project.ProjectName}
      </option>
    );
  });

  // Modals
  const [infoModal, setInfoModal] = useState({
    open: false,
    title: "",
    desc: "",
    rowData: null,
  });
  const [isKpiAssistantOpen, setIsKpiAssistantOpen] = useState(false);
  const [editModal, setEditModal] = useState({
    open: false,
    rootCause: "",
    solution: "",
    kpis: [],
    decompositionId: "",
  });

  const [isLocalAgentOpen, setLocalAgentOpen] = useState(false);
  const [aiPanelField, setAiPanelField] = useState(null);
  const [aiSuggestion, setAiSuggestion] = useState(null);
  const [aiLoading, setAiLoading] = useState(false);

  const handleAiAssist = async (field) => {
    setAiPanelField(field);
    setAiLoading(true);
    setAiSuggestion(null);
    const scenarioId = field === 'rootCause' ? 'risk_root_cause'
                     : field === 'solution'  ? 'risk_solution'
                     : 'risk_kpi_suggest';
    try {
      const payload = localAgentService.buildRiskRegisterPayload({
        projectId, editModal, overviewData
      });
      const result = await localAgentService.runLocalAgentAnalysis('risk_register', scenarioId, payload);
      if (result && result.success) {
        setAiSuggestion(result.analysis);
      }
    } catch (err) {
      console.error("AI Assist handler error in Risk Register:", err);
    } finally {
      setAiLoading(false);
    }
  };

  const [expandedKPI, setExpandedKPI] = useState(null);


  // ------------------ API calls ------------------
  const getOverview = useCallback(async () => {
    try {
      setLoading(true)
      setLoading(true)
      const res = await axios.get(
        `${config.laravelBaseUrl}getOverViewRiskProfile/${projectId}`,
        {
          headers: {
            authorization: "Bearer " + sessionStorage.getItem("userToken"),
            "x-user-id": localStorage.getItem("UserId") || "",
            "x-tenant-schema": "Amplo111",
            "x-user-email": sessionStorage.getItem("userEmail") || localStorage.getItem("userEmail") || ""
          }
        }
      );
      const rawData = res.data.data;
      const parsed = (Array.isArray(rawData) ? rawData : []).map(row => ({
        ...row,
        KPIs: row.KPIs
          ? (typeof row.KPIs === "string" ? JSON.parse(row.KPIs) : row.KPIs)
          : []
      }));
      setOverviewData(parsed);
      setLoading(false)
    } catch {
      setLoading(false)
      responseMessage("Error", "Failed to fetch overview data", "");
    }
  }, [projectId]);

  const getActivity = useCallback(async () => {
    try {
      const res = await axios.get(
        `${config.laravelBaseUrl}getActivityRiskProfile/${projectId}`,
        {
          headers: {
            authorization: "Bearer " + sessionStorage.getItem("userToken"),
            "x-user-id": localStorage.getItem("UserId") || "",
            "x-tenant-schema": "Amplo111",
            "x-user-email": sessionStorage.getItem("userEmail") || localStorage.getItem("userEmail") || ""
          }
        }
      );
      const rawData = res.data.data;
      setActivityData(Array.isArray(rawData) ? rawData : []);
    } catch {
      responseMessage("Error", "Failed to fetch activity data", "");
    }
  }, [projectId]);

  const getSelected = useCallback(async () => {
    try {
      const res = await axios.get(
        `${config.laravelBaseUrl}getRiskProfileselCapability/${projectId}`,
        {
          headers: {
            authorization: "Bearer " + sessionStorage.getItem("userToken"),
            "x-user-id": localStorage.getItem("UserId") || "",
            "x-tenant-schema": "Amplo111",
            "x-user-email": sessionStorage.getItem("userEmail") || localStorage.getItem("userEmail") || ""
          }
        }
      );
      const rawData = res.data.data;
      setSelectedCapabilities(Array.isArray(rawData) ? rawData : []);
    } catch {
      responseMessage("Error", "Failed to fetch selected capabilities", "");
    }
  }, [projectId]);

  const getUnselected = useCallback(async () => {
    try {
      const res = await axios.get(
        `${config.laravelBaseUrl}getRiskProfileUnselCapability/${projectId}`,
        {
          headers: {
            authorization: "Bearer " + sessionStorage.getItem("userToken"),
            "x-user-id": localStorage.getItem("UserId") || "",
            "x-tenant-schema": "Amplo111",
            "x-user-email": sessionStorage.getItem("userEmail") || localStorage.getItem("userEmail") || ""
          }
        }
      );
      const rawData = res.data.data;
      setUnselectedCapabilities(Array.isArray(rawData) ? rawData : []);
    } catch {
      responseMessage("Error", "Failed to fetch unselected capabilities", "");
    }
  }, [projectId]);

  const saveRiskProfilPainPoint = async () => {
    const obj = {
      projectId,
      decompositionprocesslevelid_1: editModal.decompositionId,
      rootcause: editModal.rootCause,
      solution: editModal.solution,
      kpis: editModal.kpis,
    };
    try {
      await axios.post(`${config.laravelBaseUrl}saveRiskProfilPainPoint/${projectId}`, obj, {
        headers: {
          authorization: "Bearer " + sessionStorage.getItem("userToken"),
          "x-user-id": localStorage.getItem("UserId") || "",
          "x-tenant-schema": "Amplo111",
          "x-user-email": sessionStorage.getItem("userEmail") || localStorage.getItem("userEmail") || ""
        },
      });
      responseMessage("success", "Saved Successfully", "");
      setEditModal({ open: false, rootCause: "", solution: "", kpis: [], decompositionId: "" });
      getOverview();
    } catch {
      responseMessage("Error", "Save failed", "");
    }
  };

  const saveRiskProfileSelection = async () => {
    dispatch(startLoader());
    try {
      setLoading(true);

      // 1. Identify newly added capabilities from unselected list
      const addedCaps = saveMatrix
        .filter((item) => item.operationType === "new_insert")
        .map((item) => {
          const rawCap = unselectedCapabilities.find(
            (uc) => String(uc.UniqueId) === String(item.UniqueId)
          );
          if (!rawCap) return null;
          return {
            id: String(rawCap.DecompositionProcessLevel1ID || rawCap.UniqueId || ""),
            name: rawCap.Capability || "",
            function: (rawCap.Function || rawCap.Domain || "").toUpperCase(),
            phase: (rawCap.Phase || rawCap.Domain || "").toUpperCase(),
            score: rawCap.Score !== undefined && rawCap.Score !== null && rawCap.Score !== "" ? parseFloat(rawCap.Score) : null,
            status: String(rawCap.Status || "1"),
            severity: String(rawCap.Priority || rawCap.severity || "high").toLowerCase()
          };
        })
        .filter(Boolean);

      // 2. Save Capability to Risk Profile selection
      await axios.post(
        `${config.laravelBaseUrl}saveRiskProfileselCapability/${projectId}`,
        {
          projectId: parseInt(projectId),
          riskProfileJson: JSON.stringify(saveMatrix),
        },
        {
          headers: {
            authorization: "Bearer " + sessionStorage.getItem("userToken"),
            "x-user-id": localStorage.getItem("UserId") || "",
            "x-tenant-schema": "Amplo111",
            "x-user-email": sessionStorage.getItem("userEmail") || localStorage.getItem("userEmail") || ""
          },
        }
      );

      // 3. Trigger local agent analysis if any capabilities were added
      if (addedCaps.length > 0) {
        try {
          for (const cap of addedCaps) {
            const payload = {
              projectId: String(projectId),
              processId: cap.id,
              capabilityName: cap.name,
              functionName: cap.function,
              phaseName: cap.phase,
              score: cap.score,
              status: cap.status,
              processes: [],
              mechanisms: [],
              connectedProcesses: [],
              rawContext: {}
            };

            const aiResult = await localAgentService.runLocalAgentAnalysis(
              MODULE_RISK_FULL_ANALYSIS,
              "generate_all",
              payload
            );

            let rootCauseText = "No root cause identified.";
            let solutionText = "No solution recommended.";
            let kpis = [];

            if (aiResult && aiResult.success && aiResult.analysis) {
              const analysis = aiResult.analysis;
              let rootCauseParts = [];
              let solutionParts = [];

              if (analysis.summary) {
                rootCauseParts.push(`Overall Summary:\n${analysis.summary}`);
              }
              if (analysis.confidence) {
                rootCauseParts.push(`Confidence Level: ${analysis.confidence}`);
              }

              if (analysis.rootCause) {
                const rcaSummary = analysis.rootCause.summary;
                const rcaWhys = Array.isArray(analysis.rootCause.whys)
                  ? analysis.rootCause.whys.map((w, idx) => `${idx + 1}. ${w}`).join('\n')
                  : "";
                if (rcaSummary) rootCauseParts.push(`Root Cause Analysis:\n${rcaSummary}`);
                if (rcaWhys) rootCauseParts.push(`Why-Tree:\n${rcaWhys}`);
              } else if (analysis.rootCauses) {
                const rcaText = analysis.rootCauses.map(rc => `- ${rc.cause}`).join('\n');
                rootCauseParts.push(`Root Cause Analysis:\n${rcaText}`);
              }

              if (analysis.solution) {
                const solSummary = analysis.solution.summary;
                const solActions = Array.isArray(analysis.solution.actions)
                  ? analysis.solution.actions.map(a => `- ${a}`).join('\n')
                  : "";
                if (solSummary) solutionParts.push(`Solution Summary:\n${solSummary}`);
                if (solActions) solutionParts.push(`Actionable Steps:\n${solActions}`);
              } else if (analysis.solutions) {
                const solText = analysis.solutions.map(s => `- ${s.action}`).join('\n');
                solutionParts.push(`Actionable Steps:\n${solText}`);
              }

              rootCauseText = rootCauseParts.join('\n\n') || "No root cause identified.";
              solutionText = solutionParts.join('\n\n') || "No solution recommended.";

              const rawKpis = analysis.kpis || analysis.kpiSuggestions;
              if (Array.isArray(rawKpis)) {
                kpis = rawKpis.map(k => ({
                  KPIName: k.name || k.KPIName || "",
                  Metric: k.metric || k.Metric || "",
                  Purpose: k.purpose || k.Purpose || "",
                  Stakeholders: k.stakeholders || k.Stakeholders || "",
                  Industry: k.department || k.Industry || ""
                }));
              }
            }

            const painPointObj = {
              projectId: String(projectId),
              decompositionprocesslevelid_1: cap.id,
              rootcause: rootCauseText,
              solution: solutionText,
              kpis: kpis
            };

            await axios.post(
              `${config.laravelBaseUrl}saveRiskProfilPainPoint/${projectId}`,
              painPointObj,
              {
                headers: {
                  authorization: "Bearer " + sessionStorage.getItem("userToken"),
                  "x-user-id": localStorage.getItem("UserId") || "",
                  "x-tenant-schema": "Amplo111",
                  "x-user-email": sessionStorage.getItem("userEmail") || localStorage.getItem("userEmail") || ""
                }
              }
            );
          }
        } catch (error) {
          console.error("Failed to run local agent analysis or save pain points:", error);
        }
      }

      responseMessage("success", "Saved successfully", "");
      setSaveMatrix([]);
      setCheckedSelected([]);
      setCheckedUnselected([]);
      getOverview();
      getSelected();
      getUnselected();
      setLoading(false);
    } catch {
      setLoading(false);
      responseMessage("Error", "Save Risk Profile failed", "");
    } finally {
      setLoading(false);
      dispatch(stopLoader());
    }
  };

  // ------------------ Lifecycle ------------------
  useEffect(() => {
    dispatch(fetchProjects());
    dispatch(GetCapabilityPainPoints(projectId, processID, true));
    getOverview();
    getActivity();
    getSelected();
    getUnselected();

    return () => {
      dispatch(resetInitiatives());
      CacheStorage.removeItem("painpoint-back-link");
    };
  }, [dispatch, projectId, processID, getOverview, getActivity, getSelected, getUnselected]);

  // ------------------ Handlers ------------------
  const handleTabSwitch = (newTab) => {
    dispatch(startLoader());
    setTab(newTab);
    setListOrDomain("list");
    setTimeout(() => dispatch(stopLoader()), 500);
  };

  const toggleSelect = (item, isSelectedList) => {
    if (isSelectedList) {
      setCheckedSelected((prev) =>
        prev.includes(item.UniqueId)
          ? prev.filter((id) => id !== item.UniqueId)
          : [...prev, item.UniqueId]
      );
    } else {
      setCheckedUnselected((prev) =>
        prev.includes(item.UniqueId)
          ? prev.filter((id) => id !== item.UniqueId)
          : [...prev, item.UniqueId]
      );
    }
  };

  const handleAdd = () => {
    const ops = checkedUnselected.map((id) => ({
      operationType: "new_insert",
      UniqueId: id,
    }));
    setSaveMatrix([...saveMatrix, ...ops]);
    setCheckedUnselected([]);
  };

  const handleRemove = () => {
    const ops = checkedSelected.map((id) => ({
      operationType: "delete",
      UniqueId: id,
    }));
    setSaveMatrix([...saveMatrix, ...ops]);
    setCheckedSelected([]);
  };

  const handleCancel = () => {
    setSaveMatrix([]);
    setCheckedSelected([]);
    setCheckedUnselected([]);
    getSelected();
    getUnselected();
  };

  const handleInfoModal = (title, desc, rawdata) => {
    setInfoModal({ open: true, title, desc, rowData: rawdata });
  };

  const handleEditModal = (data) => {
    let kpis = [];
    if (data.KPIs) {
      try {
        kpis = typeof data.KPIs === "string" ? JSON.parse(data.KPIs) : data.KPIs;
      } catch (e) {
        kpis = [];
      }
    }

    setEditModal({
      open: true,
      rootCause: data.RootCause || "",
      solution: data.Solution || "",
      kpis,
      decompositionId: data.DecompositionProcessLevel1ID,
    });
  };


  const toCamelCase = (str = "") =>
    str
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  const renderStructuredText = (text) => {
    if (!text) return <p className="text-muted">No data found.</p>;

    // Split text into paragraphs/sections by double newlines
    const sections = text.split(/\n\n+/);

    return (
      <div className="structured-info-container">
        {sections.map((section, secIdx) => {
          const lines = section.trim().split('\n');
          if (lines.length === 0) return null;

          const firstLine = lines[0];

          // 1. Check if it's Confidence Level
          if (firstLine.toLowerCase().startsWith("confidence level:")) {
            const levelVal = firstLine.replace(/confidence level:\s*/i, "").trim();
            const lowerLevel = levelVal.toLowerCase();
            let badgeBg = "bg-primary";
            let percent = "";
            if (lowerLevel.includes("high") || lowerLevel.includes("92")) {
              badgeBg = "bg-success";
              percent = " (92%)";
            } else if (lowerLevel.includes("medium") || lowerLevel.includes("78")) {
              badgeBg = "bg-info";
              percent = " (78%)";
            } else if (lowerLevel.includes("low") || lowerLevel.includes("54")) {
              badgeBg = "bg-warning text-dark";
              percent = " (54%)";
            }
            return (
              <div key={secIdx} className="mb-4 d-flex align-items-center">
                <span className="text-secondary font-weight-bold mr-2" style={{ fontSize: '14px' }}>Confidence Level:</span>
                <span className={`badge ${badgeBg} py-2 px-3 rounded-pill text-uppercase`} style={{ fontSize: '11px', fontWeight: '600', letterSpacing: '0.5px' }}>
                  {levelVal}{!levelVal.includes("%") && percent}
                </span>
              </div>
            );
          }

          // 2. Check if the section starts with a heading/title (e.g. ends with ":" or starts with specific words)
          const isHeading = firstLine.endsWith(":") || 
                            firstLine.toLowerCase().startsWith("overall summary") ||
                            firstLine.toLowerCase().startsWith("capability-specific") ||
                            firstLine.toLowerCase().startsWith("root cause analysis") ||
                            firstLine.toLowerCase().startsWith("why-tree") ||
                            firstLine.toLowerCase().startsWith("solution summary") ||
                            firstLine.toLowerCase().startsWith("actionable steps") ||
                            firstLine.toLowerCase().startsWith("evidence") ||
                            firstLine.toLowerCase().startsWith("general recommendations");

          if (isHeading) {
            const title = firstLine.replace(/:$/, "");
            const contentLines = lines.slice(1);

            return (
              <div key={secIdx} className="mb-4 card border-0 bg-light p-3 rounded-lg shadow-sm" style={{ borderLeft: '4px solid #0056b3' }}>
                <h6 className="text-primary font-weight-bold mb-3 d-flex align-items-center" style={{ fontSize: '15px' }}>
                  <i className={`fa ${title.toLowerCase().includes("summary") ? "fa-align-left" : title.toLowerCase().includes("root") || title.toLowerCase().includes("cause") ? "fa-wrench" : title.toLowerCase().includes("solution") || title.toLowerCase().includes("action") ? "fa-lightbulb" : "fa-info-circle"} mr-2`}></i>
                  {title}
                </h6>
                <div className="text-dark" style={{ fontSize: '14px', lineHeight: '1.6' }}>
                  {contentLines.map((line, lIdx) => {
                    const trimmedLine = line.trim();
                    if (trimmedLine.startsWith("-") || trimmedLine.startsWith("*")) {
                      return (
                        <div key={lIdx} className="d-flex mb-2 align-items-start pl-2">
                          <span className="text-primary mr-2" style={{ marginTop: '2px' }}>•</span>
                          <span>{trimmedLine.substring(1).trim()}</span>
                        </div>
                      );
                    }
                    if (/^\d+\./.test(trimmedLine)) {
                      return (
                        <div key={lIdx} className="d-flex mb-2 align-items-start pl-2">
                          <span className="text-primary font-weight-bold mr-2">{trimmedLine.match(/^\d+\./)[0]}</span>
                          <span>{trimmedLine.replace(/^\d+\.\s*/, "").trim()}</span>
                        </div>
                      );
                    }
                    return <p key={lIdx} className="mb-2" style={{ whiteSpace: 'pre-wrap' }}>{line}</p>;
                  })}
                </div>
              </div>
            );
          }

          // 3. Render regular paragraphs/text
          return (
            <div key={secIdx} className="mb-3 px-2" style={{ fontSize: '14px', lineHeight: '1.6', color: '#333' }}>
              {lines.map((line, lIdx) => {
                const trimmedLine = line.trim();
                if (trimmedLine.startsWith("-") || trimmedLine.startsWith("*")) {
                  return (
                    <div key={lIdx} className="d-flex mb-2 align-items-start">
                      <span className="text-primary mr-2" style={{ marginTop: '2px' }}>•</span>
                      <span>{trimmedLine.substring(1).trim()}</span>
                    </div>
                  );
                }
                return <p key={lIdx} className="mb-2" style={{ whiteSpace: 'pre-wrap' }}>{line}</p>;
              })}
            </div>
          );
        })}
      </div>
    );
  };


  // ------------------ Render tables ------------------
  const renderOverviewTable = () => (
    <table className="table mt-4 table-fixx-block">
      <thead className="thead-dark">
        <tr style={{ display: "table", width: "100%" }}>
          <th style={{ width: "7%" }}>SL NO.</th>
          <th style={{ width: "15%" }}>Capability</th>
          <th style={{ width: "15%" }}>Function</th>
          <th style={{ width: "15%" }}>Phase</th>
          <th style={{ width: "10%" }}>Root Cause</th>
          <th style={{ width: "10%" }}>Solution</th>
          <th style={{ width: "10%" }}>KPI</th>
          <th style={{ width: "15%" }}>Last Updated</th>
          <th style={{ width: "15%" }}>Edit</th>
        </tr>
      </thead>
      <tbody>
        {overviewData.length === 0 ? (
          <tr>
            <td colSpan={9} style={{ paddingTop: "35px" }}>
              You have not yet added any capability into your Risk Profile.
            </td>
          </tr>
        ) : (
          overviewData.map((row, i) => (
            <tr key={i} style={{ display: "table", width: "100%" }}>
              <td style={{ width: "7%" }}>{i + 1}</td>
              <td style={{ width: "15%" }}>{row.Capability || ""}</td>
              <td style={{ width: "15%" }}>{toCamelCase(row.Function) || ""}</td>
              <td style={{ width: "15%" }}>{toCamelCase(row.Phase) || ""}</td>
              <td style={{ width: "10%" }}>
                <a
                  onClick={() => handleInfoModal("Root Cause", row.RootCause)}
                  style={{ cursor: "pointer" }}
                >
                  <i className="fa fa-wrench"></i>
                </a>
              </td>
              <td style={{ width: "10%" }}>
                <a
                  onClick={() => handleInfoModal("Solution", row.Solution)}
                  style={{ cursor: "pointer" }}
                >
                  <i className="fa fa-lightbulb"></i>
                </a>
              </td>
              <td style={{ width: "10%" }}>
                <a
                  onClick={() => handleInfoModal("KPI", row.KPIs, row)}
                  style={{ cursor: "pointer" }}
                >
                  <i className="fa fa-chart-line"></i>
                </a>
              </td>
              <td style={{ width: "15%" }}>{row.ModifiedDate || ""}</td>
              <td style={{ width: "15%" }}>
                <a
                  onClick={() => row.Status !== 0 && handleEditModal(row)}
                  style={{
                    cursor: row.Status === 0 ? "not-allowed" : "pointer",
                    opacity: row.Status === 0 ? 0.5 : 1,
                  }}
                >
                  <i className="fa fa-edit"></i>
                </a>

              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );

  const renderActivityTable = () => (
    <table className="table mt-4 table-fixx-block">
      <thead className="thead-dark">
        <tr style={{ display: "table", width: "100%" }}>
          <th style={{ width: "7%" }}>SL NO.</th>
          <th style={{ width: "25%" }}>Capability</th>
          <th style={{ width: "15%" }}>Updated By</th>
          <th style={{ width: "15%" }}>Last Updated Date</th>
        </tr>
      </thead>
      <tbody>
        {activityData.length === 0 ? (
          <tr>
            <td colSpan={4} style={{ paddingTop: "35px" }}>
              No activity available.
            </td>
          </tr>
        ) : (
          activityData.map((row, i) => (
            <tr key={i} style={{ display: "table", width: "100%" }}>
              <td style={{ width: "7%" }}>{i + 1}</td>
              <td style={{ width: "25%" }}>{row.Capability || ""}</td>
              <td style={{ width: "15%" }}>{row.ModifiedBy || ""}</td>
              <td style={{ width: "15%" }}>{row.ModifiedDate || ""}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );

  const renderRiskProfileTable = () => (
    <div className="risk-profile-section">
      <Row>
        <Col xl="6">
          <div className="card shadow-sm mb-4">
            <div className="card-header text-center bg-light font-weight-bold">
              Risk Profile Capabilities
            </div>
            <div className="card-body p-0">
              <table className="table mb-0">
                <thead className="thead-dark">
                  <tr>
                    <th style={{ width: "5%" }}>#</th>
                    <th style={{ width: "45%" }}>Capability</th>
                    <th style={{ width: "20%" }}>Domain</th>
                    <th style={{ width: "10%" }}>AFly Score</th>
                    <th style={{ width: "10%" }}>Priority</th>
                    <th style={{ width: "10%" }}>Select</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedCapabilities.map((row, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{row.Capability}</td>
                      <td>{toCamelCase(row.Domain)}</td>
                      <td>{row.Score}</td>
                      <td>{row.Priority}</td>
                      <td>
                        <input
                          type="checkbox"
                          checked={checkedSelected.includes(row.UniqueId)}
                          onChange={() => toggleSelect(row, true)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Col>

        <Col xl="6">
          <div className="card shadow-sm mb-4">
            <div className="card-header text-center bg-light font-weight-bold">
              Unselected Capabilities
            </div>
            <div className="card-body p-0">
              <table className="table mb-0">
                <thead className="thead-dark">
                  <tr>
                    <th style={{ width: "5%" }}>#</th>
                    <th style={{ width: "45%" }}>Capability</th>
                    <th style={{ width: "20%" }}>Domain</th>
                    <th style={{ width: "10%" }}>AFly Score</th>
                    <th style={{ width: "10%" }}>Priority</th>
                    <th style={{ width: "10%" }}>Select</th>
                  </tr>
                </thead>
                <tbody>
                  {unselectedCapabilities.map((row, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{row.Capability}</td>
                      <td>{toCamelCase(row.Domain)}</td>
                      <td>{row.Score}</td>
                      <td>{row.Priority}</td>
                      <td>
                        <input
                          type="checkbox"
                          checked={checkedUnselected.includes(row.UniqueId)}
                          onChange={() => toggleSelect(row, false)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Col>

        <Col xl="12" className="text-center mt-4">
          <div className="risk-btn-group d-flex justify-content-center flex-wrap gap-3">
            <button
              className="btn-modern add"
              onClick={handleAdd}
              disabled={!checkedUnselected.length}
            >
              <span className="icon"><i className="fa fa-plus"></i></span>
              Add
            </button>

            <button
              className="btn-modern remove"
              onClick={handleRemove}
              disabled={!checkedSelected.length}
            >
              <span className="icon"><i className="fa fa-trash"></i></span>
              Remove
            </button>

            <button
              className="btn-modern cancel"
              onClick={handleCancel}
            >
              <span className="icon"><i className="fa fa-undo"></i></span>
              Cancel
            </button>

            <button
              className="btn-modern done"
              onClick={handleDoneClick}
              disabled={!saveMatrix.length}
            >
              <span className="icon"><i className="fa fa-check-circle"></i></span>
              Done
            </button>
          </div>
        </Col>


      </Row>
    </div>
  );

  const addKPI = () => {
    setEditModal((prev) => ({
      ...prev,
      kpis: [...(prev.kpis || []), { KPIName: "", Metric: "", Purpose: "", Stakeholders: "", Industry: "" }],
    }));
  };

  const removeKPI = (index) => {
    setEditModal((prev) => ({
      ...prev,
      kpis: (prev.kpis || []).filter((_, i) => i !== index),
    }));
  };


  const updateKPI = (index, field, value) => {
    setEditModal((prev) => {
      const newKpis = [...(prev.kpis || [])];
      newKpis[index][field] = value;
      return { ...prev, kpis: newKpis };
    });
  };



  const handleDoneClick = () => {
    swal({
      title: "Are you sure?",
      text: "Painpoint Initiative will run for new Risk Profile Capabilities and will take approx 30-40 minutes to complete.\n\nAdd, delete or update not allowed until completion.\n\nRun Painpoint Initiative now?",
      icon: "info",
      buttons: [
        "No, go back to edit",
        "Yes, Run Painpoint Initiative"
      ],
      dangerMode: false,
    }).then((isConfirm) => {
      if (isConfirm) {
        saveRiskProfileSelection();
      }
    });
  };

  const toggleKPI = (index) => {
    setExpandedKPI(expandedKPI === index ? null : index);
  };

  const handleImportKPI = (kpi, row) => {
    const kpiObj = {
      KPITitle: kpi.KPIName,
      Metrics: kpi.Metric,
      Description: kpi.Purpose,
      CapabilityID: row.Capability,
      FunctionID: row.Function,
      PhaseID: row.Phase,
      DecompositionProcessLevel1ID: row.DecompositionProcessLevel1ID,
      Stakeholders: kpi.Stakeholders || ""
    };

    dispatch(createKpi(kpiObj));

  };

  // ------------------ Render ------------------
  return (
    <>
      <DashboardHeader />
      <div id="wrapper" style={{ marginTop: "1rem" }}>
        <DashboardSidebar />


        <Loader loading={loading} />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <ol className="breadcrumb dashbread">
              <li className="breadcrumb-item">
                <Link to="/dashboard">Home</Link>
              </li>
              <li className="breadcrumb-item">Capability Modeling</li>
              <li className="breadcrumb-item active">Painpoint Initiative</li>
            </ol>
            <Row className="business-decomposition-sec mt-4 align-items-center">
              {/* Back Button */}
              {/* <Col xl="1" className="d-flex align-items-center">
                <Link onClick={handleBackClick} className="backlink">
                  <button
                    style={{ padding: 7, marginRight: "10px" }}
                    type="button"
                    className="btn btn-outline-primary"
                  >
                    <i className="fa fa-angle-left"></i> Back
                  </button>
                </Link>
              </Col> */}

              {/* Project Label + Dropdown */}
              <Col xl="6" style={{ marginLeft: '1rem' }}>
                <div className="model-list">
                  <Label className="model-label mb-1">Capability Modeling Project:</Label>
                  <select
                    className="form-control"
                    style={{ width: "auto" }}
                    name="project"
                    disabled
                    value={projectId}
                  >
                    <option value={0}>Select Project</option>
                    {projectOptions}
                  </select>
                </div>
              </Col>

              {/* Right side (empty for now) */}
              <Col xl="3" className="text-right"></Col>
            </Row>

            <PainPointsWrapper>
              <div className="container-fluid container-dashboard">
                {/* Tabs */}
                <div
                  className="d-flex justifyContent-start align-items-center heatmap-header"
                  style={{ width: "480px", gap: "10px" }}
                >
                  {/* AgenticFloatingButton is rendered at the root level */}
                  <button
                    type="button"
                    className={
                      tab === "overview" ? "btn btn-primary" : "btn btn-outline-primary-tab"
                    }
                    style={{ marginRight: "10px" }}
                    onClick={() => handleTabSwitch("overview")}
                  >
                    Overview
                  </button>
                  <button
                    type="button"
                    className={
                      tab === "riskprofile" ? "btn btn-primary" : "btn btn-outline-primary-tab"
                    }
                    style={{ marginRight: "10px" }}
                    onClick={() => handleTabSwitch("riskprofile")}
                  >
                    Risk Profile
                  </button>
                  <button
                    type="button"
                    className={
                      tab === "activity" ? "btn btn-primary" : "btn btn-outline-primary-tab"
                    }
                    onClick={() => handleTabSwitch("activity")}
                  >
                    Activity
                  </button>
                </div>

                {/* Tab Content */}
                <div className="card table-section mt-0 mb-5">
                  <div className="card-body">
                    {tab === "overview" && renderOverviewTable()}
                    {tab === "riskprofile" && renderRiskProfileTable()}
                    {tab === "activity" && renderActivityTable()}
                  </div>
                </div>
              </div>
            </PainPointsWrapper>
          </div>
        </div>
      </div>

      {/* Info Modal */}
      <ModalPopup
        isOpen={infoModal.open}
        className="modal-lg"
        toggle={() => setInfoModal({ ...infoModal, open: false })}
        title={
          infoModal.title === "KPI" ? (
            <>
              <span>KPI</span>
              <div style={{ position: 'absolute', right: '50px', top: '12px' }}>
                <PremiumAgenticButton 
                  label="KPI Assistant"
                  onClick={() => setIsKpiAssistantOpen(true)}
                  style={{ padding: '4px 12px', fontSize: '12px' }}
                />
              </div>
            </>
          ) : infoModal.title
        }
      >
        <div className="row mt-2 mb-4">
          {infoModal.title === "KPI" && Array.isArray(infoModal.desc) ? (
            infoModal.desc.length > 0 ? (
              <div className="col-12" style={{ maxHeight: "500px", overflowY: "auto", overflowX: "hidden", paddingRight: "10px" }}>
                <div className="row">
                  {infoModal.desc.map((kpi, index) => (
                    <div key={index} className="col-md-6 mb-4">
                      <div
                        className="card h-100 border-0 rounded-lg"
                        style={{
                          boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 8px, rgba(0, 0, 0, 0.1) 0px 1px 3px",
                        }}
                      >
                        {/* Title */}
                        <div className="card-header bg-light text-primary font-weight-bold text-center">
                          {kpi.KPIName}
                        </div>

                        {/* Always visible */}
                        <div className="card-body p-3">
                          <p className="mb-2">
                            <strong>Metric:</strong> {kpi.Metric}
                          </p>

                          {/* Details - hidden by default */}
                          {expandedKPI === index && (
                            <div className="kpi-details mt-2">
                              <p className="mb-2"><strong>Purpose:</strong> {kpi.Purpose}</p>
                              {kpi.Stakeholders && (
                                <p className="mb-2"><strong>Stakeholders:</strong> {kpi.Stakeholders}</p>
                              )}
                              {kpi.Industry && (
                                <p className="mb-0"><strong>Industry:</strong> {kpi.Industry}</p>
                              )}
                            </div>
                          )}
                        </div>

                        {/* Footer */}
                        <div className="card-footer bg-white d-flex justify-content-between">
                          <button
                            className="btn btn-sm btn-outline-info"
                            onClick={() => toggleKPI(index)}
                          >
                            <i className="fa fa-eye mr-1"></i>
                            {expandedKPI === index ? "Hide Details" : "View Details"}
                          </button>
                          <button
                            className="btn btn-sm btn-success"
                            onClick={() => handleImportKPI(kpi, infoModal.rowData)}
                          >
                            <i className="fa fa-download mr-1"></i> Import KPI
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="col-12 text-center text-muted">No KPIs found.</div>
            )
          ) : (
            <div className="col-12">
              {renderStructuredText(infoModal.desc)}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary ml-3"
            onClick={() => setInfoModal({ ...infoModal, open: false })}
          >
            Close
          </button>
        </div>
      </ModalPopup>


      {/* Edit Modal */}
      <ModalPopup
        className="modal-lg"
        isOpen={editModal.open}
        toggle={() =>
          setEditModal({
            open: false,
            rootCause: "",
            solution: "",
            kpis: [],
            decompositionId: "",
          })
        }
        title="Edit Painpoint Initiative"
      >
        <div className="row mt-2 mb-4">
          <div className="col-sm-12">
            <div className="form-group" style={{ position: 'relative' }}>
              <label style={{ display: 'flex', alignItems: 'center' }}>
                Root Cause <span className="text-danger">*</span>
                <AiAssistIcon
                  onClick={() => handleAiAssist('rootCause')}
                  tooltip="AI-suggest root cause"
                  loading={aiLoading && aiPanelField === 'rootCause'}
                  theme="light"
                />
              </label>
              <textarea
                className="form-control"
                value={editModal.rootCause}
                onChange={(e) =>
                  setEditModal({ ...editModal, rootCause: e.target.value })
                }
                style={{ height: "155px" }}
              />
              <AiSuggestionPanel
                isOpen={aiPanelField === 'rootCause'}
                onClose={() => setAiPanelField(null)}
                mode="text"
                loading={aiLoading}
                suggestion={aiSuggestion}
                onAccept={(text) => {
                  setEditModal(prev => ({ ...prev, rootCause: text }));
                  setAiPanelField(null);
                }}
                onRegenerate={() => handleAiAssist('rootCause')}
              />
            </div>
          </div>
          <div className="col-sm-12">
            <div className="form-group" style={{ position: 'relative' }}>
              <label style={{ display: 'flex', alignItems: 'center' }}>
                Solution <span className="text-danger">*</span>
                <AiAssistIcon
                  onClick={() => handleAiAssist('solution')}
                  tooltip="AI-suggest solution"
                  loading={aiLoading && aiPanelField === 'solution'}
                  theme="light"
                />
              </label>
              <textarea
                className="form-control"
                value={editModal.solution}
                onChange={(e) =>
                  setEditModal({ ...editModal, solution: e.target.value })
                }
                style={{ height: "155px" }}
              />
              <AiSuggestionPanel
                isOpen={aiPanelField === 'solution'}
                onClose={() => setAiPanelField(null)}
                mode="text"
                loading={aiLoading}
                suggestion={aiSuggestion}
                onAccept={(text) => {
                  setEditModal(prev => ({ ...prev, solution: text }));
                  setAiPanelField(null);
                }}
                onRegenerate={() => handleAiAssist('solution')}
              />
            </div>
          </div>
          <hr></hr>
          <div className="col-sm-12">
            <div className="form-group" style={{ position: 'relative' }}>
              <label style={{ display: 'flex', alignItems: 'center' }}>
                KPIs <span className="text-danger">*</span>
                <AiAssistIcon
                  onClick={() => handleAiAssist('kpi')}
                  tooltip="AI-suggest KPIs"
                  loading={aiLoading && aiPanelField === 'kpi'}
                  theme="light"
                />
              </label>
              <AiSuggestionPanel
                isOpen={aiPanelField === 'kpi'}
                onClose={() => setAiPanelField(null)}
                mode="kpi"
                loading={aiLoading}
                suggestion={aiSuggestion}
                onAppendKpis={(selectedKpis) => {
                  setEditModal(prev => ({
                    ...prev,
                    kpis: [...(prev.kpis || []), ...selectedKpis]
                  }));
                  setAiPanelField(null);
                }}
                onRegenerate={() => handleAiAssist('kpi')}
              />

              {(editModal.kpis || []).map((kpi, index) => (
                <div key={index} className="card p-3 mb-3 shadow-sm">
                  <div className="form-row">
                    <div className="col-md-6 mb-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="KPI Name"
                        value={kpi.KPIName}
                        onChange={(e) => updateKPI(index, "KPIName", e.target.value)}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Metric"
                        value={kpi.Metric}
                        onChange={(e) => updateKPI(index, "Metric", e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group mb-2">
                    <textarea
                      className="form-control"
                      placeholder="Purpose"
                      value={kpi.Purpose}
                      onChange={(e) => updateKPI(index, "Purpose", e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-row">
                    <div className="col-md-6 mb-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Stakeholders (optional)"
                        value={kpi.Stakeholders}
                        onChange={(e) => updateKPI(index, "Stakeholders", e.target.value)}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Industry (optional)"
                        value={kpi.Industry}
                        onChange={(e) => updateKPI(index, "Industry", e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="text-center mt-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-danger"
                      onClick={() => removeKPI(index)}
                    >
                      <i className="fa fa-trash mr-1"></i> Remove KPI
                    </button>
                  </div>

                </div>
              ))}

              <button
                type="button"
                style={{ marginLeft: '1rem' }}
                className="btn btn-sm btn-outline-primary"
                onClick={addKPI}
              >
                + Add KPI
              </button>
            </div>
          </div>

        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary ml-3"
            onClick={() =>
              setEditModal({
                open: false,
                rootCause: "",
                solution: "",
                kpis: [],
                decompositionId: "",
              })
            }
          >
            Cancel
          </button>

          {editModal.rootCause?.length > 2 &&
            editModal.solution?.length > 2 &&
            (editModal.kpis?.length > 0 &&
              editModal.kpis.every(k => k.KPIName && k.Metric && k.Purpose)) ? (
            <button
              className="btn btn-primary ml-3"
              onClick={saveRiskProfilPainPoint}
            >
              Save
            </button>
          ) : (
            <button className="btn btn-primary ml-3" disabled>
              Save
            </button>
          )}
        </div>

      </ModalPopup>

      <LocalAgentDrawer
        isOpen={isLocalAgentOpen}
        onClose={() => setLocalAgentOpen(false)}
        moduleKey="risk_register"
        scenarios={RISK_REGISTER_SCENARIOS}
        title="Risk Register Analysis"
        projectName={overviewData[0] ? overviewData[0].ProjectName || 'Risk Profile' : 'Risk Profile'}
        contextData={{
          projectId,
          overviewData,
          editModal
        }}
        onAppendKpis={(selectedKpis) => {
          setEditModal(prev => ({
            ...prev,
            kpis: [...(prev.kpis || []), ...selectedKpis]
          }));
        }}
      />

      {/* KPI Assistant Drawer */}
      <LocalAgentDrawer
        isOpen={isKpiAssistantOpen}
        onClose={() => setIsKpiAssistantOpen(false)}
        moduleKey="kpi_assistant"
        scenarios={getScenariosByModule('kpi_assistant')}
        title="KPI Assistant"
        projectName={overviewData[0] ? overviewData[0].ProjectName || 'Risk Profile' : 'Risk Profile'}
        contextData={infoModal.rowData}
      />

      <FooterComponent />
    </>
  );
}
